import React from 'react'
import { Link } from 'react-router-dom'

const SubHeader = (props) => {
    return (
        <>
            <section className="subheader-bannerbg">
                <div className="container">
                <Link className='text-muted text-decoration-none' to='/'>Home</Link>
                <i class="fa-solid fa-angle-right px-3 text-muted"></i><span className='text-muted'>{props.message}</span>
                    <p className='banner-heading'>{props.message}</p>
                </div>
            </section>

        </>
    )
}

export default SubHeader
